import { format } from "date-fns";
import ruLocale from "date-fns/locale/ru";
import enLocale from "date-fns/locale/en-US";

export const defaultValue = "default";

const formatDate = (str: string, isRuLocale?: boolean) =>
  format(Date.now(), str, { locale: isRuLocale ? ruLocale : enLocale });

export enum ScalingFactor {
  Default = 1,
  Thousands = 0.001,
  Millions = 0.000001,
  Acres = 0.01,
  Hectares = 0.0001,
}

export const numberOptions = [
  {
    value: ScalingFactor.Default.toString(),
    localizationKey: "defaultValue",
  },
  {
    value: ScalingFactor.Thousands.toString(),
    localizationKey: "inThousands",
  },
  {
    value: ScalingFactor.Millions.toString(),
    localizationKey: "inMillions",
  },
  {
    value: ScalingFactor.Acres.toString(),
    localizationKey: "inAcres",
  },
  {
    value: ScalingFactor.Hectares.toString(),
    localizationKey: "inHectares",
  },
];

export const pointOptions = [
  {
    value: defaultValue,
    localizationKey: "defaultValue",
  },
  {
    value: "DD MM SS",
    localizationKey: "degreesMinutesSeconds",
  },
  {
    value: "DD.",
    localizationKey: "decimalDegrees",
  },
];

export const dateOptions = [
  {
    text: formatDate("dd.MM.yyyy"),
    value: "dd.MM.yyyy",
  },
  {
    text: formatDate("dd MMMM yyyy", true),
    value: "dd MMMM yyyy",
  },
  {
    text: formatDate("yyyy, dd MMMM", true),
    value: "yyyy, dd MMMM",
  },
];

export const timeOptions = [
  {
    text: formatDate("kk:mm:ss"),
    value: "hh:mm:ss",
  },
  {
    text: formatDate("hh:mm:ss aa"),
    value: "hh:mm:ss tt",
  },
  {
    text: formatDate("kk:mm"),
    value: "hh:mm",
  },
  {
    text: formatDate("hh:mm aa"),
    value: "hh:mm tt",
  },
];
